/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

const HeadingWrapper = styled.div`
    padding-left: 20px;
    padding-right: 20px;
	display: flex;
	background: #d9d7d7;
	border-top
`;

const HeadingItem = styled.div`
	flex: 1;
	width: 20%;
	padding: 11px 0 9px;

	text-align: center;
	font-size: 13px;
	color: #${({isCurrent}) => isCurrent ? '42affa' : '95989a'};
	font-weight: 500;

	+ div {
		border-left: 1px solid #9d9d9d;
	}
`;

const today = moment().locale('de').format('dd DD.MM.YYYY');

const Heading = ({items = []}) => (
    <HeadingWrapper>
        {items.map(item => (
            <HeadingItem key={`heading-${item}`} isCurrent={item === today}>
                {item}
            </HeadingItem>
        ))}
    </HeadingWrapper>
);

export default Heading;



// WEBPACK FOOTER //
// ./src/components/dashboard/grid/header.js